<template>
    <v-row justify="space-between" v-if="retrieveAccountCustomerCredit">
        <v-col cols="12" md="3" lg="2">
            <v-list-item two-line>
                <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">£ {{retrieveAccountCustomerCredit.salesLedgerBalance}}</v-list-item-title>
                    <v-list-item-subtitle>Account Balance</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-col>
        <v-col cols="12" md="5" lg="7" >
            Available to Spend <strong>£ {{retrieveAccountCustomerCredit.availableCredit}}</strong>
            <v-progress-linear
                background-color="error"
                color="success"
                :value="BarValue"
                height= "12"
                bottom 
                rounded
            >
            </v-progress-linear>
        </v-col>
        <v-col cols="12" md="3" lg="2">
            <v-list-item two-line >
                <v-list-item-content >
                    <v-list-item-title class="font-weight-bold">£ {{retrieveAccountCustomerCredit.creditLimit}}</v-list-item-title>
                    <v-list-item-subtitle>Credit Limit</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-col>
    </v-row>
    
</template>
<script>
import {mapGetters} from "vuex"
export default {
    name :'AccountCredit',
    data :()=>{
        return{
            
        }
    },
    computed:{
        ...mapGetters(['retrieveAccountCustomerCredit']),
        BarValue(){
             let spentPercent = (this.retrieveAccountCustomerCredit.salesLedgerBalance / this.retrieveAccountCustomerCredit.creditLimit) * 100
            return 100- spentPercent
        },
    }
}
</script>